/**
 * 處理 ?lang= query 參數的語系切換
 * 收到 ?lang= 參數時自動修改 URL path 到對應語系
 */
export default defineNuxtRouteMiddleware((to) => {
  const queryLang = to.query.lang

  if (!queryLang || typeof queryLang !== 'string') return

  const { $i18n } = useNuxtApp()
  const supportedLocales = $i18n.locales.value.map((l) => l.code)
  const defaultLocale = $i18n.defaultLocale

  // 驗證語系是否支援
  if (!supportedLocales.includes(queryLang)) {
    console.warn(`[i18n-query] Locale "${queryLang}" is not supported. Available:`, supportedLocales)
    return
  }

  // 從 URL 路徑判斷當前語系（不使用 $i18n.locale.value，因為它可能已被更新）
  let currentLocaleFromPath = defaultLocale
  let basePath = to.path
  for (const loc of supportedLocales) {
    if (to.path.startsWith(`/${loc}/`)) {
      currentLocaleFromPath = loc
      basePath = to.path.substring(loc.length + 1)
      break
    } else if (to.path === `/${loc}`) {
      currentLocaleFromPath = loc
      basePath = '/'
      break
    }
  }

  // 如果目標語系與當前路徑語系相同，只需移除 lang 參數
  if (currentLocaleFromPath === queryLang) {
    const { lang, ...otherQuery } = to.query
    if (Object.keys(otherQuery).length > 0) {
      return navigateTo({ path: to.path, query: otherQuery }, { replace: true })
    }
    return
  }

  console.info(`[i18n-query] Switching locale from ${currentLocaleFromPath} to ${queryLang}`)

  // 更新 i18n cookie，防止 detectBrowserLanguage 又重定向回原語系
  const localeCookie = useCookie('i18n_locale', {
    maxAge: 60 * 60 * 24 * 365,
    sameSite: 'lax',
  })
  localeCookie.value = queryLang

  // 同時更新 i18n 的 locale 值
  $i18n.locale.value = queryLang

  // 添加目標語系前綴
  let targetPath
  if (queryLang === defaultLocale) {
    targetPath = basePath || '/'
  } else {
    targetPath = `/${queryLang}${basePath === '/' ? '' : basePath}`
  }

  // 移除 lang 參數，保留其他 query 參數
  const { lang, ...otherQuery } = to.query

  return navigateTo({ path: targetPath, query: otherQuery }, { replace: true })
})